import { motion } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { ChevronDownIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, FlexGap, IconWrapper, QuillText } from '@treams/treams-ui';

const ChevronWrapper = styled(IconWrapper)<{ open: boolean }>`
	transition: transform 120ms ease-out;
	transform: ${(props) => (props.open ? 'rotate(180deg)' : 'none')};
	display: flex;
`;

const MoreInformationContent = styled(Box)`
	background: ${(props) => props.theme.tokens.surface.secondary};
	border: 1px solid ${(props) => props.theme.tokens.border.subtle};
	border-radius: ${(props) => props.theme.tokens.radius.md}px;
`;

export function FeedbackQuestionMoreInformation(props: {
	additionalDetails: graphql.FeedbackRequestQuestion['additionalDetails'];
}) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	return (
		<FlexGap mt={3} gap={8} flexDirection="column" alignItems="flex-start">
			<Button
				small
				type="secondary"
				title={t('feedback.answer.moreInformation')}
				rightIcon={
					<ChevronWrapper open={open}>
						<ChevronDownIcon />
					</ChevronWrapper>
				}
				onClick={() => setOpen((value) => !value)}
			/>
			<AnimatePresence>
				{open && (
					<motion.div
						initial={{ opacity: 0, height: 0 }}
						animate={{ opacity: 1, height: 'auto' }}
						exit={{ opacity: 0, height: 0 }}
						transition={{ duration: 0.2, ease: 'easeInOut' }}
					>
						<MoreInformationContent p={3}>
							<QuillText value={props.additionalDetails} />
						</MoreInformationContent>
					</motion.div>
				)}
			</AnimatePresence>
		</FlexGap>
	);
}
